module.exports = __webpack_public_path__ + "img/wuhan-1.6e0db2ec.jpg";